import { cn } from '@/lib/utils';

const STATUS_LABEL = {
	healthy: 'Healthy',
	hiccup: 'Hiccup',
	down: 'Down',
	pending: 'Pending'
};

const STATUS_CLASS = {
	healthy: 'bg-success-soft',
	hiccup: 'bg-warning-soft',
	down: 'bg-destructive/30',
	pending: 'bg-muted'
};

/**
 * 30-day connection uptime strip. Each `day` is
 * `{ date, status, inStock?, totalUploaded? }` — status derived by the
 * Inventory accuracy page from the `stock_count` upload history.
 *
 * The per-bar tooltip is a plain CSS `group-hover` panel rather than a Radix
 * Tooltip: with 30 adjacent triggers the old Radix tooltip flickers open/closed
 * as the pointer crosses bars. A `pointer-events-none` panel can't steal hover,
 * so it stays put.
 */
export function UptimeBar({ days }) {
	return (
		<div>
			<div className="flex items-stretch gap-1">
				{days.map((d, i) => {
					const label = STATUS_LABEL[d.status] ?? 'Pending';
					return (
						<div key={i} className="group relative flex-1">
							<div
								className={cn(
									'h-7 w-full cursor-default rounded-[4px] transition group-hover:scale-y-110',
									STATUS_CLASS[d.status] ?? STATUS_CLASS.pending
								)}
								aria-label={`${d.date} — ${label}`}
							/>
							<div className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 hidden -translate-x-1/2 whitespace-nowrap rounded-md bg-foreground px-3 py-2 text-xs text-background shadow-soft group-hover:block">
								<div className="mb-1 text-sm font-semibold">{d.date}</div>
								{typeof d.inStock === 'number' ? (
									<div>
										<span className="font-semibold">In stock barcodes:</span>{' '}
										<span className="tabular-nums">{d.inStock.toLocaleString()}</span>
									</div>
								) : null}
								{typeof d.totalUploaded === 'number' ? (
									<div>
										<span className="font-semibold">Total barcodes:</span>{' '}
										<span className="tabular-nums">{d.totalUploaded.toLocaleString()}</span>
									</div>
								) : null}
								<div>
									<span className="font-semibold">Status:</span> {label}
								</div>
							</div>
						</div>
					);
				})}
			</div>
			<div className="mt-2 flex items-center justify-between text-[11px] text-muted-foreground">
				<span>{days.length} days ago</span>
				<span>Today</span>
			</div>
		</div>
	);
}
